
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[insightType]/[slug]",
      function () {
        return require("private-next-pages/[insightType]/[slug].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[insightType]/[slug]"])
      });
    }
  